import { render, staticRenderFns } from "./FormQuiz.vue?vue&type=template&id=7606466c&scoped=true"
import script from "./FormQuiz.vue?vue&type=script&lang=js"
export * from "./FormQuiz.vue?vue&type=script&lang=js"
import style0 from "./FormQuiz.vue?vue&type=style&index=0&id=7606466c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7606466c",
  null
  
)

export default component.exports